export default "__VITE_ASSET__BO2DULSi__"